function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.95 11.527a.93.93 0 00-.19-.774.931.931 0 00-.72-.34H10.033a.927.927 0 01-.91-.743l-.259-1.299a.927.927 0 00-.91-.742H1.96a.929.929 0 00-.91 1.113l2.412 12.065c.089.432.47.743.91.742h14.812c.442 0 .822-.31.91-.742.383-1.92 1.404-7.02 1.857-9.28zM4.54 5.773V2.06c0-.513.415-.928.928-.928h12.064c.513 0 .928.415.928.928v6.496M7.324 3.916h7.888M11.036 6.7h4.176",
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgArchived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _ref);
}

export default SvgArchived;